import React, { useState } from 'react';

// Campo de contraseña que no dispara el "¿Guardar contraseña?" del navegador
// en cada ingreso (pedido de Mica, 2026-10-27). El navegador ofrece guardar
// cuando ve un campo type="password": acá es un campo de texto con los
// caracteres tapados por CSS. Si el navegador no soporta ese CSS, queda como
// contraseña común (mejor que el pedido de guardar a que se vea la clave).
// Trae un ojito para ver lo que se escribe (Mica, 2026-10-30).
const TAPA_SOPORTADA = typeof CSS !== 'undefined' && CSS.supports?.('-webkit-text-security', 'disc');

function CampoClave({ value, onChange, mostrar = false, style, ...resto }) {
  const [ver, setVer] = useState(false);
  const visible = mostrar || ver;
  return (
    <div style={{ position: 'relative', width: '100%' }}>
      <input
        {...resto}
        type={visible || TAPA_SOPORTADA ? 'text' : 'password'}
        value={value}
        onChange={onChange}
        autoComplete="off"
        autoCapitalize="none"
        autoCorrect="off"
        spellCheck={false}
        data-lpignore="true"
        data-1p-ignore="true"
        style={{ ...style, paddingRight: '48px', WebkitTextSecurity: visible ? 'none' : 'disc' }}
      />
      <button
        type="button"
        onClick={() => setVer((v) => !v)}
        aria-label={visible ? 'Ocultar contraseña' : 'Ver contraseña'}
        title={visible ? 'Ocultar contraseña' : 'Ver contraseña'}
        style={{
          position: 'absolute', right: '4px', top: '50%', transform: 'translateY(-50%)',
          marginTop: style?.marginTop ? `calc(${style.marginTop} / 2)` : 0,
          width: '40px', height: '40px', border: 'none', background: 'none',
          cursor: 'pointer', fontSize: '20px', lineHeight: 1, padding: 0,
          display: 'flex', alignItems: 'center', justifyContent: 'center',
        }}
      >
        {visible ? '🙈' : '👁️'}
      </button>
    </div>
  );
}

export default CampoClave;
